﻿

import * as xlib from "../xlib/index.js";

import _ = xlib.lodash;
import __ = xlib.lolo;
//////////////////////////////////
/**
 *  copied from pjsc-account/io-datatypes.ts
 */
export module domains {

	class DomainConfig {
		/** prefers https, if available */
		public origin: string;
		/** if http is available, uses that */
		public originHttpPrefered: string;
		constructor( public domain: string, public httpPort: number, public httpsPort: number ) {

			this.origin = `${ httpsPort == null ? "http://" : "https://" }${ domain }:${ httpsPort == null ? httpPort : httpsPort }`;
			this.originHttpPrefered = `${ httpPort != null ? "http://" : "https://" }${ domain }:${ httpPort != null ? httpPort : httpsPort }`;

		}
	}

	export var dashboard = new DomainConfig( "dashboard.phantomjscloud.com", 80, 443 );
	export var www = new DomainConfig( "phantomjscloud.com", 80, 443 );
	export var api = new DomainConfig( "phantomjscloud.com", 80, 443 );

	switch ( xlib.environment.envLevel ) {
		case xlib.environment.EnvLevel.PROD:
			break;
		case xlib.environment.EnvLevel.DEV:
			www = new DomainConfig( "local.phantomjscloud.com", 23080, 23446 );
			dashboard = new DomainConfig( "local.phantomjscloud.com", 23081, 23444 );
			api = new DomainConfig( "local.phantomjscloud.com", 80, 443 );
			break;
		//case xlib.environment.EnvLevel.TEST:
		//	dashboard = new DomainConfig("dashboard-test.phantomjscloud.com", 80, 443);
		//	www = new DomainConfig("www-test.phantomjscloud.com", 80, 443);
		//	api = new DomainConfig("api-test.phantomjscloud.com", 80, 443);
		//	break;
		default:
			throw new Error( "env settings not specified" );
	}

	/**
	 * Server: public origin overrides (`PJSC_ORIGIN_*`, validated by src/runtime-env.ts), else the envLevel defaults above.
	 * Browser (R5): the server's resolved origins from `/client-env.js` (`window.__PJSC_CLIENT_ENV`, routes-app `clientEnvScript`); required.
	 */
	const browserEnv = typeof window !== "undefined" ? ( window as any ).__PJSC_CLIENT_ENV : undefined;
	if ( typeof window !== "undefined" && ( browserEnv == null || browserEnv.origins == null ) ) {
		throw new Error( "window.__PJSC_CLIENT_ENV missing: the page must load /client-env.js before its bundle" );
	}
	function originOverride( key: string, current: DomainConfig ): DomainConfig {
		const browserKey = { PJSC_ORIGIN_DASHBOARD: "dashboard", PJSC_ORIGIN_WWW: "www", PJSC_ORIGIN_API: "api" }[ key ];
		const value = browserEnv != null ? browserEnv.origins[ browserKey ] : typeof process !== "undefined" && process.env != null ? process.env[ key ] : undefined;
		if ( !value ) {
			return current;
		}
		const url = new URL( value );
		const isHttps = url.protocol === "https:";
		const port = url.port ? Number( url.port ) : ( isHttps ? 443 : 80 );
		return new DomainConfig( url.hostname, isHttps ? null : port, isHttps ? port : null );
	}
	dashboard = originOverride( "PJSC_ORIGIN_DASHBOARD", dashboard );
	www = originOverride( "PJSC_ORIGIN_WWW", www );
	api = originOverride( "PJSC_ORIGIN_API", api );
}

export module googleAnalytics {

	export var trackingCode = "UA-28255112-7"; //Novaleaf / PhantomJsCloud.com
	if ( __.isProd !== true ) {
		trackingCode = "UA-28255112-11"; //Novaleaf / uat.phantomjscloud.com
	}
}


export module routes {
	/**
	 * api route paths so we don't need to hardcode strings
	 */
	export var apiRoutePaths = {
		auth_login_email_test: "/api/auth/login/emailtest",
		auth_login_email: "/api/auth/login/email",
		auth_logout: "/api/auth/logout",
		//
		auth_resetPassword_start: "/api/auth/resetPassword/start",
		auth_resetPassword_finish: "/api/auth/resetPassword/finish",

		auth_signup_email_start: "/api/auth/signup/email/start",
		auth_signup_email_finish: "/api/auth/signup/email/finish",

		account_accountDetails: "/api/account/accountDetails",
		//account_creditBalance: "/api/account/creditBalance",
		//account_currentPlan: "/api/account/currentPlan",
		//account_billingDetails: "/api/account/billingDetails",
		account_allSubscriptionPlans: "/api/account/allSubscriptionPlans",
		account_purchasePrepaidCredit: "/api/account/purchasePrepaidCredit",
		account_changeSubscription: "/api/account/changeSubscription",
		balance_getBalance: "/api/balance/getBalance",
		balance_getBalanceForceRefresh: "/api/balance/getBalanceForceRefresh",
		balance_decrementBalance: "/api/balance/decrementBalance",

		/** account page key list (PjscApiKeys #202610291041_1): add / delete one key of the login session's account; reply = { apiKeys } */
		account_apiKeyAdd: "/api/account/apiKeyAdd",
		account_apiKeyDelete: "/api/account/apiKeyDelete",

		/** FreeUseAbuse Banned Domains rows for pjsc-api (byte-identical in src/apps/pjsc-api/dev/_pjsc-config/shared-config.ts) */
		antifraud_freeUseAbuseBannedDomains: "/api/antifraud/freeUseBannedDomains",

		usageMetrics_accumulate: "/api/metrics/accumulate", //metrics 0.5rps, balace 0.5rps


		account_changeBillingSource: "/api/account/changeBillingSource",

		/** whether auto add $20 when under $1 prepaid credit */
		account_setAutoAdd: "/api/account/setAutoAdd",
		/** query autoAdd state */
		account_getAutoAdd: "/api/account/getAutoAdd",

		//statement_getPendingStatement: "/api/statement/getPendingStatement",
		//statement_getById: "/api/statement/getForDate",
		//statement_getStatement: "/api/statement/getStatement",
		//statement_getChargeDates: "/api/statement/getStatement",
		statement_getStatementPublic: "/api/statement/getStatementPublic",
		statement_getSettings: "/api/statement/getSettings",
		statement_setSettings: "/api/statement/setSettings",
	}
	/**
	 *  collection of route paths used by this SPA (to avoid typos)
	 */
	export var spaRoutePaths = {
		login: "/login",
		signup: "/signup",
		signupEmailCheckEmail: "/signupEmailCheckEmail",
		signupEmailSetPassword: "/signupEmailSetPassword",
		resetPasswordStart: "/resetPasswordStart",
		resetPasswordFinish: "/resetPasswordFinish",
		root: "/",
		accountDetails: "/accountDetails",
		statements: "/statements",
	}



}


/** account page key texts (PjscApiKeys #202610291041_2, #202610291041_3): the server's refusal replies and the page's modals */
export module apiKeys {
	/** the delete confirmation's warning (user 2026-10-29: "may take up to 1 hour to propogate") */
	export const DELETE_WARNING = "Deleting a key may take up to 1 hour to propagate. Until then, requests using it may still be accepted.";
	/** a key add/delete route missing (an older server) or an account-state reply without the key list */
	export const PAGE_OUT_OF_DATE = "This page is out of date. Please reload the page and try again.";
	export const REFUSAL_TEXT = {
		lastKey: "You cannot delete your last API key. Every account must keep at least one key. Add a new key first, then delete this one.",
		createLimit: "You can create at most 3 API keys per 24 hours. Please try again later.",
		keyLimit: "Your account already has the maximum of 3 API keys. Delete a key before adding a new one.",
		/** the key is not an active key of this account (already deleted, or the page is out of date) */
		notFound: PAGE_OUT_OF_DATE,
	};
}

export const BILLING_CONSTANTS = {
	/**
* monthlyEquivelant / creditsPerDayDivisor = creditBalance_refill_credits_per_day
* calculated from the "stage2 roi calculations" spreadsheet
*/
	creditsPerDayDivisor: 6.998811,

	pricePerHour: 0.15,
	pricePerGb: 0.25,
	/** estimated using 2sec+50kb/page, see the "stage2 roi calculations" spreadsheet */
	estimatedPricePerPage: 0.00009525426229,
	/** plans we need to query for specifically via code, we use stripe metadata to query them */
	planInternalId: {
		/** stripe plan metadata key used to select the default free plan.  This plan will be displayed, but choosing results in canceling any existing plans (without subscribing to this one) */
		free: "free",
		ipNoAccount: "ipNoAccount",
		invalidApiKey: "invalidApiKey",
	},

	/** if stripe can not be contacted, these are the default values we'll use to calculate daily subscription creditBalances */
	backupDailySubscription: {
		ip: 0.1,
		free: 0.366667,
		paid: 7.77,
	},
	defaultPrepaidBalance: {
		ipNoAccount: 0.001,
		free: 0.001,
	},
	isBeta: false,
	/** tax rate for woodinville, as per http://dor.wa.gov/content/findtaxesandrates/salesandusetaxrates/lookupataxrate/default.aspx */
	tax: 0.086,
}


/**
 * creditBalance balance api
 */
export module balance {

	const balancePreRetryInterceptFcn = ( err: any ) => {
		if ( err.response == null || err.response.status >= 500 ) {
			return Promise.resolve();
		}
		return Promise.reject( new xlib.exception.HttpStatusCodeException( `invalid Api Key. Use either 'a-demo-key-with-low-quota-per-ip-address' or create an account.  GetBalance failed.`, err.response.status, new Error( __.JSONX.inspectStringify( err.response.data ) ) ) );
	};

	export let getBalance_ezEndpointFunction = new xlib.net.EzEndpoint<Payload_SubmitGetBalance, IBalance>( { origin: domains.dashboard.origin, path: routes.apiRoutePaths.balance_getBalance }, undefined, undefined, balancePreRetryInterceptFcn );

	export let decrementBalance_ezEndpointFunction = new xlib.net.EzEndpoint<Payload_SubmitTestDecrementBalance, IBalance>( { origin: domains.dashboard.origin, path: routes.apiRoutePaths.balance_decrementBalance }, { max_tries: 3, backoff: 2, interval: 200 }, undefined, balancePreRetryInterceptFcn );

	export interface IBalance {
		dailySubscriptionBalance: number;
		prepaidBalance: number;
		/** epoch timestamp from when this was returned from the account server */
		timestamp: number;
		/** set only on billing replies (`getBalance`, `decrementBalance`) for a LEECH_USER account with a free balance (`src/antifraud/leech.ts`) */
		leechUser?: boolean;
		/** set only on billing replies (`getBalance`, `decrementBalance`) for a deleted key before its `tombstoneAt`, with a zero balance (`src/apikeys/lookup.ts`); pjsc-api then refuses the key */
		keyRevoked?: boolean;
	}

	export class Payload_SubmitGetBalance extends xlib.PayloadTemplate<Payload_SubmitGetBalance> {

		public apiKey: string;

		constructor( jsonPayload: string | Buffer ) {

			super( jsonPayload, { apiKey: "" } );
		}
	}
	export class Payload_SubmitTestDecrementBalance extends xlib.PayloadTemplate<Payload_SubmitTestDecrementBalance> {

		public apiKey: string;
		public amountToDecrement: number;

		constructor( jsonPayload: string | Buffer ) {

			super( jsonPayload, { apiKey: "", amountToDecrement: 0 } );
			//make sure decrement amount is positive
			xlib.validation.scrub( { amountToDecrement: this.amountToDecrement } ).isNumber().isReal().is( ( value ) => value > 0 ).failThrow();
		}
	}

	/**
	 * returns price in Credits (USD)
	 * @param bytes
	 * @param ms
	 */
	export function calculateCost( bytes: number, ms: number ): number {
		let byteCost = bytes * BILLING_CONSTANTS.pricePerGb / 1024 / 1024 / 1024;
		let msCost = ms * BILLING_CONSTANTS.pricePerHour / 60 / 60 / 1000;
		let totalCost = byteCost + msCost;
		return totalCost;
	}

}

